import { Typography } from '@mui/material'
import { X } from 'react-feather'
import theme from 'src/styles/theme'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  

  @media (max-width: 768px) {
    position: relative;
    top: unset;
    left: unset;
    transform: unset;
  }
`

export const Modal = styled.div`
  background: ${theme.colors.gray};
  border-radius: 16px;
  width: 100%;

  @media (max-width: 768px) { width: 80%; }
`

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 0 16px;
  padding-top: 16px;

  @media (max-width: 768px) {
    padding: 0 8px;
    padding-top: 16px;
  }
`

export const TitleLabel = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  margin-left: 24px;
`

export const ModalBody = styled.div`
  padding: 32px 64px;

  @media (max-width: 768px) { padding: 16px; }
`

export const CloseModalButton = styled(X)`
  align-self: center;
  cursor: pointer;
`

export const Subtitle = styled(Typography)`
  border-bottom: 1px solid ${theme.colors.red};
`

export const TipsList = styled.ul`
  margin-top: 16px;
  list-style: disc;
  color: ${theme.colors.gray3};
  font-weight: 400;
  padding-left: 16px;
`
